/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailShipping_viewer = {|
  +requestForAllEnabled: ?boolean;
  +shipmentQuotes: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "requestForAllEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableRequestQuoteForAllLoggedIn",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"enableRequestQuoteForAllLoggedIn\"}"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "searchView",
          "value": "PDP",
          "type": "SearchView"
        }
      ],
      "concreteType": "ShipmentQuotesConnection",
      "name": "shipmentQuotes",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "shippingHelpers_shipmentQuotesConnection",
          "args": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
